export default __webpack_public_path__ + "static/media/frog.7fb3b0b0.svg";